import { Box, Dialog, IconButton, Typography, useTheme } from '@mui/material'
import React, { useCallback, useEffect, useState } from 'react'
import ReplicateQuizForm from './ReplicateQuizForm'
import NewQuizForClassForm from './NewQuizFromClassForm'
import { useUserStore } from '../../../../store/user.store'
import { Icons } from '../../../../utils/utilities'
import ManageNewQuestionBank from './ManageNewQuestionBank'
import { observer } from 'mobx-react'
import { useRoomStore } from '../../../../store/room.store'

const AddQuizFromClassDialog = observer( ( { fetchQuizzesInstances, setCreateMode, room, state, setState } ) => {

    const [addMode, setAddMode] = useState( false )
    const [loadingSubjects, setLoadingSubjects] = useState( false )
    const [newBankId, setNewBankId] = useState( 57 )
    const [questionBankMode, setQuestionBankMode] = useState( 'select' )

    const UserStore = useUserStore()
    const RoomStore = useRoomStore()

    const { palette } = useTheme()

    const handleClose = async ( fetchClassesDataAgain = false, quizInstance = null ) => {
        setState( null )
        if ( fetchClassesDataAgain && quizInstance ) {
            RoomStore.fetchViewerAndPresenterRooms( room.selected_date, [quizInstance] )
        }
    }

    const getSubjects = useCallback( async () => {
        setLoadingSubjects( true )
        await UserStore.fetchUserSubjects()
        setLoadingSubjects( false )
    }, [UserStore] )

    useEffect( () => {
        if ( UserStore.getErrorsStatuses?.subjects === true )
            getSubjects()
    }, [UserStore, getSubjects] )

    return (
        <Dialog open={state} slotProps={{
            paper: { sx: { width: "90%", maxWidth: "2000px" } }
        }} >
            <Box padding="20px" display="flex" position="sticky" top="0" bgcolor={palette.background.paper} sx={{ zIndex: 1 }} alignItems="center" justifyContent="space-between">
                <Box>
                    <Typography variant="h6">Add quiz to the class</Typography>
                    <Typography variant="body2">{room.course_short_name ? `${room.course_short_name}, ` : ""} {room.branch_name ? `${room.branch_name}, ` : ""} {room.batch_short_name !== "NA" ? <span>Batch: <em>{room.batch_short_name}</em></span> : <span>Section: <em>{room.section_short_name}</em></span>}</Typography>
                </Box>
                <IconButton size="small" onClick={() => handleClose()} >{Icons.default.CloseIcon}</IconButton>
            </Box>
            <Box display="grid" gridTemplateColumns={{ md: questionBankMode !== 'managequestions' ? "1fr" : "1fr 1fr", xs: "1fr" }} >
                {!addMode ? <ReplicateQuizForm fetchQuizzesInstances={fetchQuizzesInstances} handleClose={handleClose} room={room} setAddMode={setAddMode} addMode={addMode} /> :
                    <Box sx={{ display: { md: "block", xs: questionBankMode === 'managequestions' ? "none" : "block" } }}>
                        <NewQuizForClassForm fetchQuizzesInstances={fetchQuizzesInstances} setNewBankId={setNewBankId} questionBankMode={questionBankMode} setQuestionBankMode={setQuestionBankMode} loadingSubjects={loadingSubjects} handleClose={handleClose} room={room} setAddMode={setAddMode} addMode={addMode} />
                    </Box>}
                {questionBankMode === 'managequestions' && newBankId && <Box sx={{ position: { md: "static", xs: "static" }, right: { md: "initial", xs: "0" }, height: { md: "initial", xs: "100%" }, background: { md: "none", xs: palette.form.formCardBg } }} flexGrow={1} padding="20px" paddingTop="20px">
                    <ManageNewQuestionBank setHasNewQuestionBankSaved={() => { }} setQuestionBankMode={setQuestionBankMode} bank_id={newBankId} />
                </Box>}
            </Box>
        </Dialog>
    )
} )

export default AddQuizFromClassDialog
